import DeleteModal from "../../components/editor/DeleteModal";
import React from "react";
import {useTranslation} from "react-i18next";
import {AlertCircleIcon} from "../../ui/icons";
import cn from "classnames";
import classes from "./DeleteScenarioModal.module.css";
import {Scenario} from "../../types";

function Header() {
  const {t} = useTranslation();

  return (
    <>
      <span>{t("components.DeleteScenarioModal.title")}</span>
    </>
  );
}

function Content({scenarios, scenarioId}: {scenarios: Scenario[]; scenarioId: string}) {
  const {t} = useTranslation();

  let scenariosWithBranchesLeadsToCurrent = scenarios
    .filter((scenario) => {
      return scenario.actions?.some((action) => {
        if (action.__typename === "ChoiceUserInputAction") {
          return action.branches.some((branch) => branch.targetScenarioId === scenarioId);
        }
        return null;
      });
    })
    .map(({id, name, isMain}) => ({id, name: isMain ? t("editorChallengeEdit.scenario.main") : name}));

  let scenariosWithNextScenarioLeadsToCurrent = scenarios
    .filter((scenario) => {
      if (scenario.nextScenario === scenarioId) {
        return true;
      }
      return null;
    })
    .map(({id, name}) => ({id, name}));

  let linksToCurrent = scenariosWithBranchesLeadsToCurrent.map((scenario) => scenario.name).join(", ");
  let linksToMain = scenariosWithNextScenarioLeadsToCurrent.map((scenario) => scenario.name).join(", ");

  return (
    <>
      <span>{t("components.DeleteScenarioModal.content")}</span>
      {(linksToCurrent.length > 0 || linksToMain.length > 0) && (
        <div className={cn(classes.warningWrapper)}>
          <AlertCircleIcon className={cn(classes.warning)} />
          <p> {t("components.DeleteScenarioModal.warningMessage")}</p>
        </div>
      )}
      <ul className={cn(classes.list)}>
        {linksToCurrent.length > 0 && (
          <li>
            <span>
              {" "}
              {t("components.DeleteScenarioModal.linksToCurrent")} {linksToCurrent}
            </span>
          </li>
        )}
        {linksToMain.length > 0 && (
          <li>
            <span>
              {" "}
              {t("components.DeleteScenarioModal.linksToMain")} {linksToMain}{" "}
            </span>
          </li>
        )}
      </ul>
    </>
  );
}

function Footer(props: React.ComponentProps<typeof DeleteModal.Footer>) {
  return <DeleteModal.Footer {...props} />;
}

const DeleteScenarioModal = {
  Header,
  Content,
  Footer,
};

export default DeleteScenarioModal;

